import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import Darbostogos from './pages/Darbostogos';
import Sventes from './pages/Sventes';
import Stovyklos from './pages/Stovyklos';
import PirtiesNamukas from './pages/PirtiesNamukas';
import Galerija from './pages/Galerija';
import Kontaktai from './pages/Kontaktai';
import Rezervacija from './pages/Rezervacija';
import PrivatumoPolitika from './pages/PrivatumoPolitika';
import ESProjektai from './pages/ESProjektai';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/darbostogos" element={<Darbostogos />} />
            <Route path="/sventes" element={<Sventes />} />
            <Route path="/stovyklos" element={<Stovyklos />} />
            <Route path="/pirties-namukas" element={<PirtiesNamukas />} />
            <Route path="/galerija" element={<Galerija />} />
            <Route path="/kontaktai" element={<Kontaktai />} />
            <Route path="/rezervacija" element={<Rezervacija />} />
            <Route path="/privatumo-politika" element={<PrivatumoPolitika />} />
            <Route path="/es-projektai" element={<ESProjektai />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#333',
              color: '#fff',
            },
            success: {
              iconTheme: {
                primary: '#22c55e',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App;
